export default __webpack_public_path__ + "833d69682fe38d33c6e5addb7b4fba27.svg";